import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmOfferState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmOfferState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmOfferSlice = createSlice({
  name: 'pmOffer',
  initialState,
  reducers: {
    setPmOffers: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmOfferLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmOfferError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmOffers, setPmOfferLoading, setPmOfferError } = PmOfferSlice.actions;

export default PmOfferSlice.reducer;
